import React, { useEffect, useState } from 'react';
import './style.scss';
import { OrderStat } from 'pages/logistics/logistics-team-stats';
import { apiService } from 'utils/api';
import { SocketIOConnection } from 'utils/socket_client';

const OrdersReceivedStat = ({ data, loading }: { data: OrderStat; loading: boolean }) => {
  const [topPolygon, setTopPolygon] = useState<string>('');
  const totalOrders = parseInt(data?.success_order_count) + parseInt(data?.failed_order_count);
  const [topPolygonLoading, setTopPolygonLoading] = useState<boolean>(false);

  const getTopPolygon = async () => {
    setTopPolygonLoading(true);
    try {
      const res = await apiService.post('logistics/top-cokitchen-polygon', {
        baseUrl: process.env.REACT_APP_ORDER_STATS_API_KEY
      });
      setTopPolygon(res?.data?.data.name ?? '');
      return res?.data?.data?.name;
    } finally {
      setTopPolygonLoading(false);
    }
  };
  const connectSocket = async () => {
    const conn = await SocketIOConnection.getConnection();
    conn.onReconnect(async () => {
      conn.joinRoom(roomName, process.env.REACT_APP_WEBOCKETAPP_KEY);
      const res: any = await getTopPolygon();
      setTopPolygon(res);
    });

    const roomName = 'logistics-top-polygon-stat';
    conn.addEventListener(roomName, 'update', (data: any) => {
      setTopPolygon(data.name);
    });
    conn.joinRoom(roomName, process.env.REACT_APP_WEBOCKETAPP_KEY);
  };
  useEffect(() => {
    setTopPolygonLoading(true);

    Promise.all([getTopPolygon()]);
    setTopPolygonLoading(false);

    connectSocket();
  }, []);

  const teamStatsArray = [
    {
      title: 'Orders completed',
      value: totalOrders,
      style: 'bg-orders-completed bg-[#141415] text-[#D9D9D9] ',
      color: 'text-white'
    },
    {
      title: 'Successful orders',
      value: data?.success_order_count,
      deviation: (parseInt(data?.success_order_count) / totalOrders) * 100 + '%',
      style: 'bg-orders-failed bg-[#F8F7F7] ',
      rate: true,
      percentage: Math.round(Number(data?.success_order_increase)) + '%',
      rateBg: true
    },
    {
      title: 'Failed orders',
      value: data?.failed_order_count,
      deviation: (parseInt(data?.failed_order_count) / totalOrders) * 100 + '%',
      style: 'bg-orders-successful bg-[#F8F7F7] ',
      color: 'text-[#E60A2B]',
      rate: true,
      percentage: Math.round(Number(data?.failed_order_increase)) + '%',
      rateBg: false
    },
    {
      title: 'Top polygon',
      value: topPolygon,
      style: 'bg-top-polygon bg-[#F8F7F7] '
    },
    {
      title: 'Avg. delivery duration',
      value: `${Math.round(data?.average_delivery_time)} mins`,
      style: 'bg-avg-duration bg-[#F8F7F7] ',
      rate: true,
      percentage: Math.round(Number(data?.average_delivery_time_increase)) + '%',
      rateBg: true
    }
  ];
  let rateBg = false;
  for (let i = 0; i < teamStatsArray.length; i++) {
    if (teamStatsArray[i].rate && teamStatsArray[i].percentage && !loading) {
      if (teamStatsArray[i].percentage?.includes('-')) {
        rateBg = false;
      } else {
        rateBg = true;
      }
      teamStatsArray[i].rateBg = rateBg;
    }
  }
  return (
    <div className='flex justify-center flex-wrap gap-[40px]'>
      {teamStatsArray.map(
        ({ title, value, deviation, style, color, rate, rateBg, percentage }, index) => (
          <div
            key={index}
            className={`${style} bg-no-repeat bg-right  text-[#6F7376] border border-[#F0EFEF] pl-[30px] min-w-[390px] pt-[30px] pb-[38px] rounded-[8px]`}>
            {loading || topPolygonLoading ? (
              '...'
            ) : (
              <>
                <div className='flex gap-4'>
                  <p>{title}</p>
                  {rate && (
                    <div
                      className={`${
                        !rateBg ? 'bg-[#E60A2B]' : 'bg-[#3FB827]'
                      } py-[1px] px-[7px] rounded-[100px] text-white`}>
                      {rateBg && '+'}
                      {percentage}
                    </div>
                  )}
                </div>
                <p>
                  <span className={`${color} text-[#2E3031] font-extrabold text-[48px]`}>
                    {value}
                  </span>
                  <span className='ml-1'>{deviation}</span>
                </p>
              </>
            )}
          </div>
        )
      )}
    </div>
  );
};
export default OrdersReceivedStat;
